import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../../../base/context/LoaderProvider";
import { ToastTypes, useMessage } from "../../../../base/context/MessageProvider";
import { FaFileInvoice, FaDownload, FaInfoCircle } from "react-icons/fa";
import "./style.css";

export default function Invoice() {
  const message = useMessage();
  const loader = useLoader();
  const navigate = useNavigate();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [invoices, setInvoices] = useState([]);

  const handleFilter = () => {
    if (!startDate || !endDate) {
      message.showToast("Please select both start and end date", ToastTypes.WARNING);
      return;
    }
    // API call would go here
    message.showToast("Invoice feature coming soon", ToastTypes.INFO);
  };

  const handleClear = () => {
    setStartDate("");
    setEndDate("");
  };

  const handleDownload = () => {
    message.showToast("Invoice download coming soon", ToastTypes.INFO);
  };

  return (
    <div className="si-page">
      {/* Info Banner */}
      <div className="si-info-banner">
        <div className="si-info-icon">
          <FaInfoCircle />
        </div>
        <div className="si-info-content">
          <span className="si-info-title">Invoice Reports - Coming Soon</span>
          <span className="si-info-text">
            The invoice report page is currently under development. After your order is dispatched, 
            the invoice will be sent to your registered email address. Thank you for your patience.
          </span>
        </div>
      </div>

      {/* Filters Section */}
      <div className="si-filters-section">
        <div className="si-filters-row">
          <div className="si-filter-group">
            <label className="si-filter-label">Start Date</label>
            <input 
              type="date" 
              className="si-date-input" 
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className="si-filter-group">
            <label className="si-filter-label">End Date</label>
            <input 
              type="date" 
              className="si-date-input" 
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
          <div className="si-filter-actions">
            <button className="si-btn si-btn-primary" onClick={handleFilter}>
              Apply Filter
            </button>
            <button className="si-btn si-btn-secondary" onClick={handleClear}>
              Clear
            </button>
            <button className="si-btn si-btn-download" onClick={handleDownload}>
              <FaDownload /> Download All
            </button>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="si-table-section">
        <div className="si-table-header">
          <span className="si-section-title">
            <FaFileInvoice /> Invoice History
          </span>
        </div>
        <div className="si-table-wrapper">
          <table className="si-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Date</th>
                <th>Transaction ID</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              {invoices.length > 0 ? (
                invoices.map((invoice, index) => (
                  <tr key={index}>
                    <td>{invoice.orderId}</td>
                    <td>{invoice.date}</td>
                    <td className="si-txn-id">{invoice.transactionId}</td>
                    <td>₹{invoice.amount?.toLocaleString()}</td>
                    <td>
                      <span className={`si-status-badge si-status-${invoice.status?.toLowerCase()}`}>
                        {invoice.status}
                      </span>
                    </td>
                    <td>
                      <button className="si-download-btn">
                        <FaDownload />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="si-no-data">
                    <div className="si-empty-state">
                      <FaFileInvoice className="si-empty-icon" />
                      <span>No invoices found</span>
                      <span className="si-empty-hint">Invoices will appear here after your orders are dispatched</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
